export class ResetUserProjectsList {
  public static readonly type = '[User/Projects] ResetUserProjectsList';
}
